var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 35"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M24.397 27.816c.19-.2 0 0-.57-1.802-.722-2.279-2.282-3.603-6.276-3.603-2.451 0-3.716.59-4.515 1.226-.423.336-.619.889-.619 1.446v6.622c0 .905.547 1.715 1.374 1.962 2.521.752 6.446 1.55 10.606.754 5.02-.96 6.683-3.603 7.416-5.404 1.712-4.204-.57-5.765-1.711-4.804-2.852 2.402-2.852 3.603-5.705 3.603Zm0 0h-5.134"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeWidth: 1.5,
  d: "M5.571 23.011c0-1.326 1.022-2.402 2.282-2.402h2.282c1.26 0 2.282 1.076 2.282 2.402v9.609c0 1.326-1.022 2.402-2.282 2.402H7.853c-1.26 0-2.282-1.076-2.282-2.402zM29.962 14.194c0 2.447-1.885 4.431-4.21 4.431-2.324 0-4.209-1.984-4.209-4.43 0-2.448 1.885-4.432 4.21-4.432 2.324 0 4.209 1.984 4.209 4.431Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#CACACA",
  fillRule: "evenodd",
  d: "M18.433 10.037c0-2.002 1.532-3.558 3.343-3.558 1.666 0 3.097 1.318 3.314 3.089a4.4 4.4 0 0 1 1.507-.01c-.23-2.54-2.27-4.58-4.821-4.58-2.71 0-4.843 2.302-4.843 5.059 0 2.6 1.895 4.794 4.383 5.036a5.2 5.2 0 0 1 .008-1.51c-1.607-.233-2.891-1.693-2.891-3.526",
  clipRule: "evenodd"
})));
export default SvgHand;